module.exports = __webpack_public_path__ + "img/code.08ac296f.png";